import React from 'react';
import { MapPinOff } from 'lucide-react';
import { useDeliveryLocation } from '../context/DeliveryLocationContext';
import { displayLabelFor } from '../utils/deliveryLocationLabels';
import { btnPrimary, btnSm, focusRing } from '../styles/ui';

// Shown when the backend resolved the selected geography and no outlet can
// deliver there. The location (and the cart) are kept: the customer only needs
// a way to try somewhere else.
const UnserviceableLocation = ({ className = '', showAction = true }) => {
  const { label, pincode, openLocationPrompt } = useDeliveryLocation();

  return (
    <div
      role="status"
      data-testid="unserviceable-location"
      className={`flex items-start gap-3 rounded-2xl border border-amber-100 bg-amber-50 px-4 py-3.5 ${className}`}
    >
      <span className="w-9 h-9 rounded-full bg-white text-amber-700 flex items-center justify-center shrink-0">
        <MapPinOff size={18} aria-hidden="true" />
      </span>
      <div className="min-w-0">
        <p className="text-sm font-bold text-amber-900">We don&apos;t deliver to this location yet.</p>
        <p className="text-xs text-amber-800 mt-0.5 break-words">
          {displayLabelFor({ label, pincode })} is outside our delivery area. Try another address or pincode.
        </p>
        {showAction && (
          <button type="button" onClick={openLocationPrompt} className={`mt-2.5 ${btnPrimary} ${btnSm} ${focusRing}`}>
            Change location
          </button>
        )}
      </div>
    </div>
  );
};

export default UnserviceableLocation;
